import { useNavigate, useLocation } from 'react-router-dom';
import { useNavigationStore } from '../store';
import type { ExtendedNavigationStore } from '../store';

/**
 * Hook for navigation functionality
 */
export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const store = useNavigationStore() as ExtendedNavigationStore;

  const navigateTo = (path: string) => {
    store.navigate(path);
    navigate(path);
    // Close mobile menu on navigation
    store.setMobileMenuOpen(false);
  };

  return {
    ...store,
    currentPath: location.pathname,
    navigate: navigateTo,
  };
};

export default useNavigation;
